var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"w-100 h-100"},[(_vm.loading)?_c('div',{staticClass:"h-100 w-100 d-flex justify-content-center position-fixed",staticStyle:{"padding-top":"250px","z-index":"6","background-color":"#ffffffb8"}},[_c('b-spinner',{attrs:{"variant":"danger"}})],1):_vm._e(),_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }